import { render, staticRenderFns } from "./AdminPage.vue?vue&type=template&id=25b27382&scoped=true"
import script from "./AdminPage.vue?vue&type=script&lang=js"
export * from "./AdminPage.vue?vue&type=script&lang=js"
import style0 from "./Basic.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "../Followups/admin-page.scss?vue&type=style&index=1&id=25b27382&prod&lang=scss&scoped=true&external"
import style2 from "./AdminPage.vue?vue&type=style&index=2&id=25b27382&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b27382",
  null
  
)

export default component.exports